module.exports = __webpack_public_path__ + "img/9788996433422.7d2dbd91.jpg";